import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = { isOpen: false };

        props.trackEvent([
            'Site Interaction',
            `${props.logged_in ? 'LI' : 'LO'} Impression`,
            'Print-Section',
        ]);

        props.trackEvent([
            'Site Interaction',
            `${props.logged_in ? 'LI' : 'LO'} Impression`,
            'Print-Report',
        ]);
    }

    componentDidMount() {
        document.addEventListener('click', this.handleGlobalClick, true);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleGlobalClick, true);
    }

    render() {
        return (
            <print-icon
                className={this.state.isOpen ? 'is-open' : ''}
                ref={el => this.el = el}
            >
                <a onClick={this.toggleMenu} className='has-text-boulder'>
                    <img
                        src='https://gfx.tarot.com/images/site/astrology/essential-birth-report-redux/print.svg'
                        alt='print'
                    />
                    <br />
                    Print
                </a>
                <div className='print-menu has-text-center'>
                    <a onClick={this.printPage}>This Section</a>
                    <span>or</span>
                    <a onClick={this.printAll}>Full Report</a>
                </div>
            </print-icon>
        );
    }

    toggleMenu = () => {
        this.setState({ isOpen: !this.state.isOpen });
    }

    printPage = () => {
        this.toggleMenu();
        this.props.trackEvent([
            'Site Interaction',
            `${this.props.logged_in ? 'LI' : 'LO'} Click`,
            'Print-Section',
        ]);
        window.print();
    }

    printAll = () => {
        this.toggleMenu();
        this.props.trackEvent([
            'Site Interaction',
            `${this.props.logged_in ? 'LI' : 'LO'} Click`,
            'Print-Report',
        ]);
        document.querySelector(this.props.selector).classList.toggle('print-all');
        window.print();
        document.querySelector(this.props.selector).classList.toggle('print-all');
    }

    handleGlobalClick = (e) => {
        if (this.state.isOpen && e.target != this.el && !this.el.contains(e.target)) {
            this.setState({ isOpen: !this.state.isOpen });
        }
    }
}

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(null, mapDispatchToProps)(Component);
